var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroLayout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1938_7047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 20H3C2.45 20 2 19.55 2 19V5C2 4.45 2.45 4 3 4H15C15.55 4 16 4.45 16 5V19C16 19.55 15.55 20 15 20ZM19 8H21C21.55 8 22 7.55 22 7V5C22 4.45 21.55 4 21 4H19C18.45 4 18 4.45 18 5V7C18 7.55 18.45 8 19 8ZM19 20H21C21.55 20 22 19.55 22 19V17C22 16.45 21.55 16 21 16H19C18.45 16 18 16.45 18 17V19C18 19.55 18.45 20 19 20ZM19 14H21C21.55 14 22 13.55 22 13V11C22 10.45 21.55 10 21 10H19C18.45 10 18 10.45 18 11V13C18 13.55 18.45 14 19 14Z",
    fill: "#727272"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1938_7047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroLayout);
export default __webpack_public_path__ + "static/media/hero_layout.9ec74ac7a925f59b243c87585461da74.svg";
export { ForwardRef as ReactComponent };